import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
// 查看页面和编辑页面公用的参数和方法
import common from '@/config';
import { config } from '@/option/config';
import container from '@/page/bigScreen/group/container';
import { getList } from '@/api/bigscreen/map';
export default {
  components: {
    container: container
  },
  provide: function provide() {
    return {
      main: this,
      contain: this
    };
  },
  data: function data() {
    return {
      DIC: {
        MAP: []
      },
      contentWidth: '',
      config: config,
      obj: {},
      id: '',
      visual: {},
      nav: [],
      common: common,
      active: [],
      overactive: ''
    };
  },
  computed: {
    list: function list() {
      var result = []; //循环处理数据

      var detail = function detail(item) {
        if (item.children) {
          item.children.forEach(function (ele) {
            detail(ele);
          });
        } else {
          result.push(item);
        }
      };

      this.nav.forEach(function (ele) {
        detail(ele);
      });
      var len = result.length - 1;
      result.forEach(function (ele, index) {
        ele.zIndex = len - index;
      });
      return result;
    }
  },
  created: function created() {
    this.initDic();
  },
  methods: {
    //初始化字典
    initDic: function initDic() {
      var _this = this;

      getList({
        current: 1,
        size: 100
      }).then(function (res) {
        var data = res.data.data;
        _this.DIC.MAP = data.records.map(function (ele) {
          return {
            label: ele.name,
            value: _this.url + '/map/data?id=' + ele.id
          };
        });
      });
    },
    findnav: function findnav(id, type) {
      var _this2 = this;

      //循环处理数据
      var obj = undefined;
      var count = 0;
      var parent = undefined;
      var pcount = 0;
      var len = 0;

      var detail = function detail(item, list, i) {
        var number = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        if (!item.children || type) {
          if (id === item.index) {
            obj = item;
            len = Array.isArray(list) ? list.length - 1 : list.children.length - 1;
            parent = list;
            pcount = number;
            count = i;
          }
        }

        if (item.children) {
          item.children.forEach(function (ele, index) {
            detail(ele, item, index, number + 1);
          });
        }
      };

      this.nav.forEach(function (ele, index) {
        detail(ele, _this2.nav, index);
      });
      return {
        obj: obj,
        count: count,
        len: len,
        pcount: pcount,
        parent: parent
      };
    },
    findlist: function findlist(index) {
      return this.list.find(function (ele) {
        return ele.index == index;
      }) || {};
    },
    handleInitActive: function handleInitActive() {
      console.log('insitacte');
      this.active = [];
    },
    handleMouseDown: function handleMouseDown() {
      this.handleInitActive();
    }
  }
};